import { Component } from '@verndale/core';

class SocialShare extends Component {
  setupDefaults() {
    this.dom = {
      trigger: this.el.querySelector('[data-toggle]')
    };
  }

  addListeners() {
    this.dom.trigger.addEventListener('click', this.toggleDropdown.bind(this));
  }

  toggleDropdown() {
    const elId = this.dom.trigger.dataset.toggle;
    const el = document.getElementById(elId);

    if (el.hidden) {
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', 'true');
    }
  }
}

export default SocialShare;
